<template>
    <Modal
			class="personas long-modal"
			width="800"
			v-model="show"
			:loading="loading"
			@on-ok="ok"
			@on-cancel="cancel"
		>
			<h3 slot="header" class="modal-header">健康情况记录</h3>
			<ul class="detail">
				<li>门店名称：{{projectName}}</li>
				<li>房间号：{{roomName}}</li>
				<li>姓名：{{name}}</li>
				<li>返程日期：{{returnDate}}</li>
				<li>返程日体温(℃)：{{bodyTemperature}}</li>
			</ul>
			<table-list
			style="margin:26px 0"
      :columns="columns"
      :data="data"
			:current="current"
      :total="total"
			:loading="loading_table"
      @change-page="changePage"
		></table-list>
    </Modal>
</template>

<script>
import TableList from 'components/TableList/index';
import {findHelthRecord} from 'api/customerhealth'
export default {
	components:{
		TableList
	},
	props:{
		n:{
			type:Number,
			default:0
		},
		returnDate:{
			type:String,
			default:''
		},
		projectName:{
			type:String,
			default:''
		},
		name:{
			type:String,
			default:''
		},
		roomName:{
			type:String,
			default:''
		},
		phone:{
			type:String,
			default:''
		},
		bodyTemperature:{
			type:Number,
			default:0
		},
		temperatureList:{
			type:Array,
      default(){
        return []
      }
		}
	},
	data(){
		return{
			show:false,
			loading:false,
			columns:[
        {
          title: '日期',
          align: 'center',
          key: 'timeKey',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '过去24小时自测体温',
          align: 'center',
          key: 'bodyTemperature',
					width: 100,
					
        },
        {
          title: ' '
				},
				{
          title: '过去24小时是否有疑似症状',
          align: 'center',
          key: 'suspectedSymptoms',
					width: 100,
					render(h,params){
						let str = ''
            if(params.row['suspectedSymptoms']=== 'true'){
              str = '是'
            } else if(params.row['suspectedSymptoms']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '过去24小时是否接触过高危人群',
          align: 'center',
          key: 'reachHighriskGroups',
					width: 100,
					render(h,params){
						let str = ''
            if(params.row['reachHighriskGroups'] === 'true'){
              str = '是'
            } else if(params.row['reachHighriskGroups'] === 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '过去24小时邻居或室友是否有疑似症状',
          align: 'center',
          key: 'neighbourSuspectedSymptoms',
					width: 100,
					render(h,params){
						let str = ''
            if(params.row['neighbourSuspectedSymptoms']=== 'true'){
              str = '是'
            } else if(params.row['neighbourSuspectedSymptoms']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '邻居的表现症状及房间号',
          align: 'center',
          key: 'symptomHouseNumber',
          width: 100,
        },
        {
          title: ' '
				},
			],
			data:[
				
			],
			loading_table:false,
			current:1,
			total:0,
			
		}
	},
	watch:{
		n(){
			this.show = true
			this.getHistory()
		}
	},
	methods:{
		getHistory(){
			findHelthRecord({
				phone:this.phone,
				page:1,
				limit:10,
			})
			.then(res=>{
				this.data = res.data.rows;
				this.data.forEach(ele=>{
					this.temperatureList.filter(item=>{
						if(item.value == ele.bodyTemperature){
							ele.bodyTemperature = item.text
						}
					})
				})
				this.total = res.data.total;
			})
			.catch( err => {
				console.log(err)
			})
		},
		ok(){

		},
		changePage(){

		},
		cancel(){

		},
	}
}
</script>

<style scoped>
	.detail li{
		width: 33%;
		float: left;
		margin-bottom: 14px;
	}
</style>